import api from './api';
import type { IProfile } from '../types/profile';

/**
 * Service function to get the authenticated user's profile.
 * @returns A promise that resolves to the user's profile object.
 */
export const getMyProfile = async (): Promise<IProfile> => {
  try {
    const response = await api.get<IProfile>('/profile/me');
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to fetch profile data.');
  }
};

/**
 * ✅ NEW: Service function to get any user's profile by ID (protected by backend for Mentor/Admin).
 * @param id - The ID of the user whose profile is to be fetched.
 * @returns A promise that resolves to the user's profile object.
 */
export const getProfileById = async (id: string): Promise<IProfile> => {
  try {
    const response = await api.get<IProfile>(`/profile/${id}`);
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error(`Failed to fetch profile for ID: ${id}.`);
  }
};


/**
 * Service function to update the authenticated user's profile.
 * @param payload - The data to update the profile with.
 * @returns A promise that resolves with the updated profile.
 */
export const updateMyProfile = async (payload: Partial<IProfile>): Promise<IProfile> => {
  try {
    const response = await api.put<IProfile>('/profile/me', payload);
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to update profile.');
  }
};